import { InjectionToken } from "@angular/core";
import { CommissionBonusDetailsPort } from "./commission-bonus-details.port";

export const COMMISSION_BONUS_DETAILS_PORT =
  new InjectionToken<CommissionBonusDetailsPort>("COMMISSION_BONUS_DETAILS_PORT");
